module.exports = __webpack_public_path__ + "img/eye.45f7335c.svg";